
import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate, useLocation } from "react-router-dom";
import { Session } from "@supabase/supabase-js";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [session, setSession] = useState<Session | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const scrollToFeaturedEvents = () => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollToFeatured: true } });
    } else {
      const featuredEventsSection = document.getElementById('featured-events');
      if (featuredEventsSection) {
        featuredEventsSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="fixed w-full z-50 bg-black">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <a href="/" className="text-3xl md:text-4xl font-bold">
              <img
                src="https://cwmaychzwkmeoulfjnhr.supabase.co/storage/v1/object/public/Media%20Assets/Slay%20LGBTQIA+%20Event%20Ticketing%20Logo%20(Compressed)%20(1).png"
                alt="Slay Logo"
                className="h-20 w-20 md:h-24 md:w-24 object-contain transition-transform hover:scale-105"
              />
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white hover:text-gray-200"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>

          <nav className={`${isMenuOpen ? "block" : "hidden"
            } absolute left-0 top-16 w-full bg-black/95 backdrop-blur-sm p-4 lg:static lg:block lg:w-auto lg:bg-transparent lg:p-0 transition-all duration-200 ease-in-out`}>
            <ul className="flex flex-col space-y-2 lg:flex-row lg:items-center lg:space-x-8 lg:space-y-0">
              <li>
                <button
                  onClick={scrollToFeaturedEvents}
                  className="text-white hover:text-gray-200 transition-colors block py-2 lg:py-0"
                >
                  Browse Events
                </button>
              </li>
              <li>
                <a
                  href="/pride-directory"
                  className="text-white hover:text-gray-200 transition-colors block py-2 lg:py-0"
                >
                  Pride Directory
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-white hover:text-gray-200 transition-colors block py-2 lg:py-0"
                >
                  About Slay
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-white hover:text-gray-200 transition-colors block py-2 lg:py-0"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};
